wpbingo.debounce = function (n, t, u) {
  var e;
  return function () {
    var a = this,
      r = arguments,
      i = function () {
        ((e = null), u || n.apply(a, r));
      },
      o = u && !e;
    (clearTimeout(e), (e = setTimeout(i, t)), o && n.apply(a, r));
  };
};
